export default __webpack_public_path__ + "static/on_premise-8b1f434ec05eb1681bde637d628b911d.png";